import React from "react"
import { Link } from "gatsby"

import blogStyle from "./blog.module.scss"

import '@formatjs/intl-displaynames/polyfill'
import '@formatjs/intl-displaynames/locale-data/en' // locale-data for en

const languageNames = new Intl.DisplayNames(['en'], {type: 'language'});

const BlogPosts = ({ lang, nodes }) => {
  
  return (
    <>
    <p>Posts in {languageNames.of(lang)}:</p>
    <ol className={blogStyle.posts}>
    {nodes
      .map((node) => {
        return (
          <li className={blogStyle.post} key={node.fields.slug}>
            <Link to={`/blog/post/${node.fields.slug}`}>
              <h2>{node.frontmatter.title}</h2>
              <p className={blogStyle.blogPostMeta}>{node.frontmatter.date}</p>
              <p>{node.frontmatter.description}</p>
            </Link>
          </li>
        )
      })
    }
    </ol>
    <br/>
    </>
  )
}

export { BlogPosts }
